import React from "react";
import { ArrowUpRight, Mail, Linkedin } from "lucide-react";
import { SITE } from "../data/mock";
import { Reveal } from "./ui/Reveal";

export const CTASection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-6">
        <Reveal>
          <div className="relative rounded-3xl sm:rounded-[36px] overflow-hidden aspect-[4/5] sm:aspect-[21/9]">
            <img
              src="/assets/ajbanner.png"
              alt="Abhinav Joshi"
              className="absolute inset-0 w-full h-full object-cover"
            />
            {/* Explicit dark overlay for guaranteed text legibility,
                regardless of how object-cover crops the photo at
                different screen widths. Stronger on the left where
                the text sits, fading out toward the right. */}
            <div className="absolute inset-0 bg-gradient-to-t sm:bg-gradient-to-r from-black/80 via-black/50 sm:via-black/40 to-black/10" />

            <div className="absolute inset-0 flex items-end sm:items-center">
              <div className="max-w-xl px-6 sm:pl-16 sm:pr-6 pb-8 sm:pb-0">
                <h2 className="text-white text-[28px] sm:text-[42px] leading-[1.1] sm:leading-[1.05] tracking-[-0.02em] font-semibold">
                  Ready to see what's possible?
                </h2>
                <p className="mt-4 text-white/80 max-w-md text-[15px] sm:text-base">
                  Join 20+ brands who've replaced gut decisions with data-driven growth strategies.
                </p>
                <a
                  href="/connect"
                  className="mt-7 inline-flex items-center gap-2 bg-white text-black pl-5 pr-4 py-3 rounded-xl text-[15px] font-medium shadow-[0_0_0_5px_rgba(255,255,255,0.15)] hover:shadow-[0_0_0_7px_rgba(255,255,255,0.2)] transition-all"
                >
                  Let's get started
                  <ArrowUpRight className="w-4 h-4" />
                </a>

                <div className="mt-7 flex items-center gap-5 text-white/90 text-sm flex-wrap">
                  <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 hover:text-white transition-colors">
                    <Mail className="w-4 h-4" /> {SITE.email}
                  </a>
                  <a href={SITE.linkedin} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors">
                    <Linkedin className="w-4 h-4" /> LinkedIn
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export const Footer = () => {
  const cols = [
    { title: "Explore", links: [{ label: "About", href: "/about" }, { label: "Success Stories", href: "/success-stories" }, { label: "Blog", href: "/category/blogs" }] },
    { title: "Tools", links: [{ label: "Discovery Engine", href: "/campaigns/" }, { label: "Campaign Optimizer", href: "/campaign_optimizer/" }, { label: "SEO Audit Tool", href: "/seo-audit/" }] },
    { title: "Site", links: [{ label: "Privacy Policy", href: "/privacy-policy" }, { label: "Sitemap", href: "/sitemap" }] },
  ];
  return (
    <footer className="bg-white border-t border-black/5">
      <div className="max-w-[1280px] mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2">
            <a href="/" className="flex items-center gap-2">
              <img src={SITE.logo} alt={SITE.name} className="h-8 w-auto" />
              <span className="text-[20px] font-semibold tracking-tight text-black">{SITE.name}</span>
            </a>
            <p className="mt-4 text-sm text-neutral-600 max-w-xs">
              Trusted growth marketing consultant helping businesses, startups, and agencies scale with proven paid advertising strategies.
            </p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <div className="text-sm font-semibold text-neutral-950">{c.title}</div>
              <ul className="mt-4 space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-neutral-600 hover:text-neutral-950 transition-colors">{l.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-6 border-t border-black/5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-sm text-neutral-500">© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
          <div className="flex items-center gap-4 text-sm text-neutral-500">
            <a href={SITE.linkedin} target="_blank" rel="noopener noreferrer" className="hover:text-neutral-950">LinkedIn</a>
            <a href={`mailto:${SITE.email}`} className="hover:text-neutral-950">Email</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
